import React from 'react';
import { Heart, GraduationCap, Church, Sparkles } from 'lucide-react';

const OCCASIONS = [
  { icon: Heart, title: 'Weddings', text: 'Coordinated bow ties for grooms and groomsmen' },
  { icon: GraduationCap, title: 'Prom & Formals', text: 'Stand out with bold colors and rhinestone styles' },
  { icon: Church, title: 'Church & Sunday Best', text: 'Classic sets that keep you sharp every week' },
  { icon: Sparkles, title: 'Galas & Events', text: 'Luxury satin and jacquard for special nights' },
];

const OccasionsGuide = () => {
  const scrollToShop = () => {
    const el = document.getElementById('bow-ties');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };
  return (
    <section id="occasions" data-testid="occasions-section" className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-serif font-bold text-[#001B2A] mb-3">Every Occasion Covered</h2>
          <p className="text-gray-600 text-lg">Whatever the moment, Johnnie has the perfect piece for it</p>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {OCCASIONS.map(({ icon: Icon, title, text }) => (
            <button
              key={title}
              onClick={scrollToShop}
              data-testid={`occasion-${title.split(' ')[0].toLowerCase()}`}
              className="group text-left p-6 sm:p-8 rounded-lg border border-gray-200 hover:border-[#7B1E2B] hover:shadow-xl transition-all duration-300"
            >
              <Icon className="h-8 w-8 text-[#7B1E2B] mb-4 group-hover:scale-110 transition-transform" />
              <h3 className="text-lg font-serif font-bold text-[#001B2A] mb-2">{title}</h3>
              <p className="text-gray-600 text-sm">{text}</p>
              <p className="text-[#7B1E2B] text-xs font-semibold mt-3 uppercase tracking-wide">Shop Now →</p>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OccasionsGuide;
